module.exports = __webpack_public_path__ + "static/media/pg.efc1bc95.jpeg";